function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Boarding");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Boarding",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  opacity: 0,
  x: 0,
  y: 0,
  width: 28,
  height: 28
}), /*#__PURE__*/React.createElement("path", {
  d: "M28,23.9978707 L28,26.9978707 L0.00195118011,26.9978707 L0.00195118011,23.9978707 L28,23.9978707 Z M27.5038805,4.4739421 C28.1814332,5.13554983 28.1626372,6.19048152 27.4618985,6.83019797 C27.3581591,6.92490341 27.2425096,7.00723918 27.1175397,7.07536149 L7.4899134,17.7745692 C6.78184582,18.1605437 5.88641729,18.0419995 5.31808851,17.4870453 L3.14255809,15.3627119 L23.9749816,4.00675758 C25.1254882,3.37960536 26.5804291,3.57222234 27.5038805,4.4739421 Z M3.29155537,11.5680099 L6.47681882,13.5396259 L3.15621103,15.3497211 L-4.59188243e-13,12.2941079 L1.42375649,11.5180046 C2.00642166,11.2003882 2.72888896,11.2197303 3.29155537,11.5680099 Z M9.37368038,2.28157561 L17.6241662,7.46309974 L12.8762404,10.0512397 L5.80250548,3.14850491 L7.4959619,2.22538553 C8.08233563,1.90574758 8.80992195,1.92752034 9.37368038,2.28157561 Z",
  id: "Combined-Shape",
  fill: "#3366CC"
})));

var SvgBoarding = function SvgBoarding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoarding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/boarding.f39258a3.svg";
export { ForwardRef as ReactComponent };